import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WebSocketExtensionClass;
function WebSocketExtension() {
  if (WebSocketExtensionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WebSocketExtension');
    WebSocketExtensionClass = $;
  }
  return WebSocketExtensionClass;
}
var WebSocketExtensionsConfigClass;
function WebSocketExtensionsConfig() {
  if (WebSocketExtensionsConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.z5d_1 = ArrayList().u2();
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0.a5e_1 = [false, false, false];
      }
      n37() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.z5d_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().m2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var tmp$ret$0 = item();
          destination.n2(tmp$ret$0);
        }
        return destination;
      }
    }
    initMetadataForClass($, 'WebSocketExtensionsConfig', WebSocketExtensionsConfig);
    WebSocketExtensionsConfigClass = $;
  }
  return WebSocketExtensionsConfigClass;
}
//region block: exports
export {
  WebSocketExtensionsConfig as WebSocketExtensionsConfig3sf1f7u7xi63m,
  WebSocketExtension as WebSocketExtensionixqq2y77p4e0,
};
//endregion

//# sourceMappingURL=WebSocketExtension.mjs.map
